export default __webpack_public_path__ + "static/media/rocks-06.7ffae639.png";